import { LOCALES } from "../locales";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  [LOCALES.ENGLISH]: {
    botQuestion:
      "Welcome! I’m RafaBot, and I’m here to help. How can I assist you today?",
    chatOpen: "Open portfolio assistant",
    chatClose: "Close portfolio assistant",
    chatDialog: "Portfolio assistant",
    chatPlaceholder: "Type your message...",
    chatSend: "Send",
    chatError: "I couldn’t reach RafaBot. Please try again.",
    chatRetry: "Retry",
    chatHeroAction: "Ask RafaBot",
    chatTitle: "RafaBot",
    chatStatus: "Portfolio guide · Online",
    chatLoading: "RafaBot is thinking",
    chatSources: "Explore in portfolio",
    chatProjectPreviews: "Projects from Rafa’s portfolio",
    chatProjectOpen: "View project",
    chatProjectScroll: "Scroll",
    chatExploreTitle: "Explore Rafa",
    chatExploreIntro: "Choose a topic, or ask your own question below.",
    chatExploreaboutLabel: "About Rafa",
    chatExploreaboutHint: "Background and interests",
    chatExploreaboutPrompt: "Who is Rafa?",
    chatExploreprojectsLabel: "Featured projects",
    chatExploreprojectsHint: "See what Rafa has built",
    chatExploreprojectsPrompt: "Show me Rafa’s featured projects.",
    chatExploreskillsLabel: "Technical skills",
    chatExploreskillsHint: "Tools, languages, and strengths",
    chatExploreskillsPrompt: "What are Rafa’s strongest technical skills?",
    chatExploreexperienceLabel: "Experience",
    chatExploreexperienceHint: "Professional journey",
    chatExploreexperiencePrompt: "Tell me about Rafa’s professional experience.",
    chatExploreservicesLabel: "Services",
    chatExploreservicesHint: "How Rafa can help",
    chatExploreservicesPrompt: "What professional services does Rafa offer?",
    hi: "HELLO WORLD!",
    im: "RAFAEL VALDEZ",
    ing: "Software Engineer",
    hero: "I develop modern web applications from frontend to backend, with an emphasis on clean code, performance, usability, and maintainable systems.",
    aboutd1:
      "I enjoy solving complex problems, exploring new technologies, and designing user experiences end to end, building responsive and visually engaging applications.",
    aboutd2:
      "I work across the full development lifecycle, from concept to launch, covering UX planning, frontend and backend development, and scalable system design. I build fast, maintainable applications and deliver production-ready solutions with clear communication.",
    aboutd3:
      "I'm continuing to deepen my expertise in AI and system design, focusing on AI-powered features, agent orchestration, and RAG systems while refining how I evaluate architectural tradeoffs and design for scalability, reliability, and long-term maintainability.",
    aboutedu: "Education:",
    abouthob: "Hobbies:",
    abouttech: "A few technologies I’ve been working with recently:",
    aboutsc1:
      "Flatiron School Full Stack Web Development, Houston, United States",
    aboutsc2: "B.A. Business Administration (UASLP), San Luis Potosí, Mexico",
    aboutsc3: "B.A. International Business (UV), Valparaíso, Chile",
    aboutp1: "Cooking",
    aboutp2: "Traveling",
    aboutp3: "Technology",
    aboutp4: "Videogames",
    servicest1: "Website Development",
    servicest2: "AI Products",
    servicest3: "Code Projects",
    servicestd1:
      "Modern, responsive websites that make your business look professional, load fast, and turn visitors into customers.",
    servicestd2:
      "Smart AI solutions that automate repetitive work, reduce operational costs, and help your business run more efficiently.",
    servicestd3:
      "Custom coding solutions that add the features you need, connect your systems, and streamline your business operations.",
    sA1: "Business websites",
    sA2: "Landing pages",
    sA3: "Portfolios",
    sB1: "Chatbots",
    sB2: "Automations",
    sB3: "Personal Assistants",
    sB4: "RAG Systems",
    sC1: "Full-Stack Apps",
    sC2: "Integrations",
    sC3: "APIs",
    drop1: "Categories",
    drop2: "All",
    drop3: "Frontend",
    drop4: "Backend",
    drop5: "Tools",
    dropp3: "Web Apps",
    dropp4: "Mobile Apps",
    projectsFiltersLabel: "Project categories",
    projectsFilterAll: "All",
    projectsFilterWeb: "Web",
    projectsFilterMobile: "Mobile",
    projectsFilterAI: "AI",
    projectsFeaturedTitle: "Featured Work",
    projectsArchiveTitle: "All Projects",
    projectsArchiveFilteredTitle: "{category} Projects",
    projectsShowMore: "Show {count} more",
    projectsShowLess: "Show less",
    projectsEmpty: "No projects found in this category.",
    projectsImageAlt: "{title} project preview",
    projectsLinkVideo: "Video",
    projectsLinkDocument: "Document",
    projectsLinkCode: "Code",
    projectsLinkWebsite: "Live Site",
    Resumet: "Interesting Things",
    Resumecon:
      "Here you can explore the old version of this website, check out my LinkedIn, and view my resume.",
    resume: "Resume",
    resumeDescription: "View or download my resume.",
    past: "Old Version",
    pastDescription: "Explore the previous version of this website.",
    linkedinDescription: "Connect and view my professional profile.",
    touch:
      "If you have a question, want to say hi, or talk about code, feel free to reach out. Oh! I almost forgot, here is your taco!",
    touchLoc: "Location",
    touchPho: "Phone",
    whats: "Also available on WhatsApp",
    title1: "ABOUT",
    title2: "SERVICES",
    title3: "SKILLS",
    botWelcome:
      "Hello! I’m an AI created from Rafa’s consciousness. You can ask me anything about his professional journey, skills, and projects. I’m here to provide you with accurate and helpful information.",
    techP1:
      "A selection of projects that reflects how I approach product development, system design, and user-focused engineering across web, mobile, and AI.",
    title4: "PROJECTS",
    title5: "GET IN TOUCH",
    nav1: "About",
    nav2: "Services",
    nav3: "Skills",
    nav4: "Projects",
    nav5: "Other",
    nav6: "Contact",
  },
};
